import React from 'react';
import FormatStandardDate from './FormatStandardDate';

export const ForecasterTable = (props) => {
  const rowEntries =  props.forecastEvaluationList;

  const contents = (rowEntries === undefined) ? (<></>) :
  (
      <>
        <h4>Forecast Evaluation</h4>
        <table className='table table-striped' aria-labelledby="tabelLabel">
          <thead>
            <tr>
              <th>DoseNumber</th>
              <th>Total In Series</th>
              <th>Earliest Date</th>
              <th>Recommended Date</th>
              <th>PastDue Date</th>
              <th>Vaccine Group</th>
              <th>Series Status</th>
            </tr>
          </thead>
          <tbody>
            {rowEntries.map((row, index) => row.seriesStatus === "Past Due" ?
              <tr key={index}>
                <td><span className="text-danger">{row.targetDoseNumber}</span></td>
                <td><span className="text-danger">{row.totalDosesInSeries}</span></td>
                <td><span className="text-danger">{FormatStandardDate(row.earliestDate)}</span></td>
                <td><span className="text-danger">{FormatStandardDate(row.recommendedDate)}</span></td>
                <td><span className="text-danger">{FormatStandardDate(row.pastDueDate)}</span></td>
                <td><span className="text-danger">{row.vaccineGroup}</span></td>
                <td><span className="text-danger">{row.seriesStatus}</span></td>
              </tr>
              :
              <tr key={index}>
                <td>{row.targetDoseNumber}</td>
                <td>{row.totalDosesInSeries}</td>
                <td>{FormatStandardDate(row.earliestDate)}</td>
                <td>{FormatStandardDate(row.recommendedDate)}</td>
                <td>{FormatStandardDate(row.pastDueDate)}</td>
                <td>{row.vaccineGroup}</td>
                <td>{row.seriesStatus}</td>
              </tr>
            )}
          </tbody>
        </table>
      </>
  );

  return (
    <div>
      {contents}
    </div>
  );
}
